import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';

var buildCommonFetchOptions = function buildCommonFetchOptions(formData, onProgress) {
  return {
    method: 'POST',
    body: formData,
    events: onProgress && _objectSpread2({}, {
      onprogress: function onprogress(e) {
        if (e.lengthComputable) {
          onProgress(e.loaded, e.total, false);
        }
      },
      onloadstart: function onloadstart(e) {
        if (e.lengthComputable) {
          onProgress(e.loaded, e.total, false);
        }
      },
      onloadend: function onloadend(e) {
        if (e.lengthComputable) {
          onProgress(e.loaded, e.total, true);
        }
      }
    })
  };
};

export { buildCommonFetchOptions };